import imageCompression from "browser-image-compression";

/**
 * Compresses profile image if file size is > 1 MB (1024 * 1024 bytes).
 * Lowers size to under 1 MB.
 */
export const compressProfileImage = async (file: File): Promise<File> => {
  const ONE_MB = 1 * 1024 * 1024;
  if (!file || file.size <= ONE_MB) {
    return file;
  }

  try {
    const options = {
      maxSizeMB: 0.95, // Target ~0.95 MB to guarantee strictly < 1 MB
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      fileType: file.type || "image/jpeg",
    };
    const compressedBlob = await imageCompression(file, options);
    const compressedFile = new File([compressedBlob], file.name, {
      type: compressedBlob.type || file.type || "image/jpeg",
      lastModified: Date.now(),
    });
    return compressedFile;
  } catch (error) {
    console.error("Profile image compression failed:", error);
    return file;
  }
};

/**
 * Compresses attendance clock in / clock out image if file size is > 200 KB (200 * 1024 bytes).
 * Lowers size to under 200 KB.
 */
export const compressAttendanceImage = async (file: File): Promise<File> => {
  const TWO_HUNDRED_KB = 200 * 1024;
  if (!file || file.size <= TWO_HUNDRED_KB) {
    return file;
  }

  try {
    const options = {
      maxSizeMB: 0.19, // Target ~194 KB to guarantee strictly < 200 KB
      maxWidthOrHeight: 1280,
      useWebWorker: true,
      fileType: "image/jpeg",
    };
    const compressedBlob = await imageCompression(file, options);
    const compressedFile = new File([compressedBlob], file.name || "selfie.jpg", {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
    return compressedFile;
  } catch (error) {
    console.error("Attendance image compression failed:", error);
    return file;
  }
};
